import { useQuery } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { merchantHistoryTabService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";

type merchantHistoryProps = {
	historyKey: string;
	fetchData: {
		page: number;
	};
	id: number;
};

const useGetMerchantHistoryQuery = ({
	historyKey,
	fetchData,
	id,
}: merchantHistoryProps) => {
	const dispatch = useDispatch();

	const { page } = fetchData || {};

	return useQuery(
		[historyKey, page],
		() => merchantHistoryTabService.getMerchantHistory({ page, id }),
		{
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
			enabled: !!id,
			cacheTime: 0,
		},
	);
};

export default useGetMerchantHistoryQuery;
